import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  image: string;
  features?: string[];
  index: number;
}

const ServiceCard = ({ title, description, features, image, index }: ServiceCardProps) => {
  const number = String(index + 1).padStart(2, '0');

  return (
    <article className="grid items-center gap-6 border-b border-white/10 py-8 md:grid-cols-12 md:gap-8 md:py-10">
      <p className="text-sm text-[#d0d0d0] md:col-span-1">{number}</p>
      <div className="md:col-span-6">
        <h3 className="text-2xl text-white">{title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-[#d0d0d0]">{description}</p>
        {features && features.length > 0 && (
          <ul className="mt-4 flex flex-wrap gap-2">
            {features.map((feature) => (
              <li key={feature} className="border border-white/15 px-3 py-1 text-xs text-white">
                {feature}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="md:col-span-5">
        <img
          src={image}
          alt={title}
          className="aspect-[16/10] w-full bg-[#1a1a1a] object-cover object-center"
          loading="lazy"
        />
      </div>
    </article>
  );
};

export default ServiceCard;
